import logger from '~/lib/logger'

/**
 * Handles the dirty work of pushing to the windows dataLayer.  If a GTM listener is watching for
 * the provided event, it will be passed along to the handler, along with any additional data.
 *
 * Note: This will always be skipped for emails ending with @bh.logo.com
 *
 * @param {object} data
 * @param {string} data.event The event name to push
 */
export const PushDataLayerEvent = async data => {
  logger.debug(`Pushing dataLayer event:`, data)
  window.dataLayer.push(data)
}
